import { schemes, zSchema } from "@zeal/common";

export const postCompanyUBODocumentFromPersonaParamsSchema = zSchema.object({
  companyID: schemes.uuid(),
  persona_inquiry_id: zSchema.string(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
});

export type TPostCompanyUBODocumentFromPersonaParams = zSchema.infer<
  typeof postCompanyUBODocumentFromPersonaParamsSchema
>;

export const postCompanyUBODocumentFromPersonaResponseSchema = zSchema.object({
  success: zSchema.boolean(),
  message: zSchema.string(),
});

export type TPostCompanyUBODocumentFromPersonaResponse = zSchema.infer<
  typeof postCompanyUBODocumentFromPersonaResponseSchema
>;
